"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByHandButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const values_1 = __importDefault(require("../values"));
const bigmath_1 = require("../bigmath");
const numberFormatter_1 = require("../numberFormatter");
require("./ByHandButton.scss");
function ByHandButton({ makeByHand, itemName, count }) {
    const isPressed = (0, react_1.useRef)(false);
    const intervalIdRef = (0, react_1.useRef)(0);
    const [MAKE_BY_HAND_INTERVAL, setIntervalId] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        return () => {
            clearInterval(intervalIdRef.current);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!makeByHand && isPressed.current) {
            isPressed.current = false;
            clearInterval(intervalIdRef.current);
        }
    }, [makeByHand]);
    return makeByHand === null ? undefined : ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.Button, { className: `make-by-hand ${isPressed.current ? "shake" : ""}`, onMouseDown: () => {
            if (makeByHand) {
                makeByHand();
                const interval = setInterval(() => {
                    if (!isPressed.current) {
                        clearInterval(intervalIdRef.current);
                        return;
                    }
                    console.log(`making ${itemName}`);
                    makeByHand();
                }, 200);
                isPressed.current = true;
                intervalIdRef.current = interval;
                setIntervalId(interval);
            }
        }, onMouseUp: () => {
            clearInterval(intervalIdRef.current);
            isPressed.current = false;
            if (makeByHand)
                makeByHand();
        }, onMouseLeave: () => {
            isPressed.current = false;
            clearInterval(intervalIdRef.current);
        }, disabled: makeByHand === false, children: [values_1.default.byHandVerbs[itemName], " ", (0, bigmath_1.bigGt)(count, 1) ? (0, numberFormatter_1.formatNumber)(count) : ""] }));
}
exports.ByHandButton = ByHandButton;
